import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { SimpleAuthService } from '@ztarmobile/zwp-services-auth';
import { AccountPaymentService, CART_TYPES, IAutoCompletePrediction, IDeviceCompatibilityV1, IFirebaseAddress, MobileCustomPlansServiceNoSync, MobilePlanItem, PlacesAutocompleteService } from '@ztarmobile/zwp-service-backend';
import { takeWhile } from 'rxjs/operators';
import { MetaService } from 'src/services/meta-service.service';
import { ModalHelper } from 'src/services/modal-helper.service';
import { ToastrHelperService } from 'src/services/toast-helper.service';
import { ACTIVATION_ROUTE_URLS, SHOP_ROUTE_URLS } from '../../app.routes.names';
import { Observable, Subscription } from 'rxjs';
import { EquipmentService } from '@ztarmobile/zwp-service-backend-v2';
import { AppState } from 'src/app/app.service';
import { NgForm } from '@angular/forms';
import { ATT, CAPTCHA_BOT_ERROR_CODE, PARAM_ERROR_MESSAGES, SKIP_DEVICE_ATT, TMO } from 'src/app/app.config';

@Component({
  selector: 'app-check-compatibility',
  templateUrl: './check-compatibility.component.html',
  styleUrls: ['./check-compatibility.component.scss']
})

export class CheckCompatibilityComponent implements OnInit, OnDestroy {
  @ViewChild('addressCompatibilityForm') addressCompatibilityForm: NgForm;
  @ViewChild('equipmentCompatibilityForm') equipmentCompatibilityForm: NgForm;
  @ViewChild('imei') equipmentNumber: ElementRef<HTMLInputElement>;

  public equipment: string;
  public processingRequest = false;
  public zipCode: string;
  public invalidZipCode = false;
  public invalidIMEI: boolean;
  public compatibleDevice: IDeviceCompatibilityV1;
  public isLoggedIn: boolean;
  public activationCode: string;
  public invalidAddress = false;
  public displayedAddressModel: any;
  public address: any;
  public setFoucs = false;
  public filteredOptions: Observable<Array<IAutoCompletePrediction>>;
  public filteredOptionsSubscription: Subscription;
  public captchaResponse: string;
  public isAutoCompleteTagVisible = false;
  public circlePercentage = 50;
  public activeStep = 1;
  public stepsDetails: Array<{ stepNumber: number; title: string }>;
  public showAddressSuccessBanner = false;
  public showAddressErrorBanner = false;
  public showDeviceResultBanner = false;
  public defaultSIM: any;
  public currentErrorMesssage: string;
  public currentAddressErrorMesssage: string;
  public allBasePlans: Array<MobilePlanItem>;
  public activationFlow = false;
  public addressCompatibilityResponse: any;
  public simValidity: any;
  public isFromActivation = false;
  public recaptchaResolvedSubscription: Subscription;

  private alive = true;
  private newPlan: MobilePlanItem;
  private streetSearchText: string;

  constructor(
    private simpleAuthService: SimpleAuthService,
    private metaService: MetaService,
    public router: Router,
    public mobileCustomPlansService: MobileCustomPlansServiceNoSync,
    public toastHelper: ToastrHelperService,
    public modalHelper: ModalHelper,
    private placesAutoCompleteService: PlacesAutocompleteService,
    private equipmentService: EquipmentService,
    private appState: AppState) {

    this.stepsDetails = [
      { stepNumber: 1, title: 'Service Coverage Check' },
      { stepNumber: 2, title: 'Device Compatibility Check' }
    ];
  }

  ngOnInit(): void {
    this.simpleAuthService.userState.pipe(takeWhile(() => this.alive)).subscribe((authState) => this.isLoggedIn = !!authState && !authState.isAnonymous);
    this.mobileCustomPlansService.isConfigurationReady.pipe(takeWhile(() => this.alive)).subscribe((isReady) => {
      if (!!isReady) {
        const savedPlanId = JSON.parse(sessionStorage.getItem('planID'));
        this.allBasePlans = this.mobileCustomPlansService.allBasePlans;
        this.newPlan = this.allBasePlans.find((plan) => plan.id === savedPlanId);
      }
    });
    this.metaService.createCanonicalUrl();
    this.mobileCustomPlansService.currentPlan.pipe(takeWhile(() => this.alive)).subscribe((plan) => {
      if (!!plan && !!plan.planDevice) {
        this.activationCode = plan.activationCode;
      }
      if (!!plan.activationCode) {
        this.activationFlow = true;
      } else {
        this.activationFlow = false;
      }
    });
    this.simValidity = JSON.parse(sessionStorage.getItem('activation'));
  }

  ngOnDestroy(): void {
    this.alive = false;
    this.filteredOptionsSubscription?.unsubscribe();
    if (this.recaptchaResolvedSubscription) {
      this.recaptchaResolvedSubscription.unsubscribe();
    }
  }

  public findPlace(keyword: ''): Observable<Array<IAutoCompletePrediction>> {
    this.filteredOptions = this.placesAutoCompleteService.findAddress(keyword);
    this.filteredOptionsSubscription = this.filteredOptions.subscribe();
    return this.filteredOptions;
  }

  public addressDetails(eventFire: IAutoCompletePrediction): void {
    if (!!eventFire && !!this.address && this.address?.main_text) {
      const event = this.address;
      if (!!event.place_id) {
        this.appState.loading = true;
        this.invalidAddress = false;
        //this is a default value until address have the value from api
        this.address = event?.main_text;
        this.placesAutoCompleteService
          .findDetailedAddressFields(event.place_id)
          .subscribe(
            (place) => {
              this.streetSearchText =
                !!place.address1 && place.address1.length > 0
                  ? place.address1
                  : null;
              this.displayedAddressModel = this.getAddressValues(
                place,
                event.main_text
              );
              this.address = `${this.displayedAddressModel?.address1}, ${this.displayedAddressModel?.city
                }, ${this.displayedAddressModel?.state} ${this.displayedAddressModel?.postalCode
                  ? this.displayedAddressModel?.postalCode
                  : ''
                }`;
              this.appState.loading = false;
            },
            (error) => {
              this.appState.loading = false;
              console.warn(
                `Google can't find details for place: ${event.place_id}`,
                error
              );
            }
          );
      } else {
        this.invalidAddress = true;
        console.warn(`Google can't find place: ${event.main_text}`);
      }
    } else {
      this.invalidAddress = true;
    }
  }

  public changedAddress(): void {
    this.findPlace(this.address);
    this.displayedAddressModel = null;
    const autoCompleteTag = document.querySelector('ngui-auto-complete');
    if (!!autoCompleteTag) {
      this.isAutoCompleteTagVisible = true;
    } else {
      this.isAutoCompleteTagVisible = false;
    }
  }

  public back(): void {
    this.activeStep = 1;
    this.showAddressSuccessBanner = false;
    this.showAddressErrorBanner = false;
  }

  public next(): void {
    this.activeStep = 2;
    this.circlePercentage = 100;
    this.showAddressSuccessBanner = false;
    this.showAddressErrorBanner = false;
    this.isFromActivation = false;
  }

  public retry(): void {
    if (this.activeStep === 1) {
      this.address = '';
      this.displayedAddressModel = null;
      this.showAddressSuccessBanner = false;
      this.showAddressErrorBanner = false;
      this.isFromActivation = false;
    } else if (this.activeStep === 2) {
      this.equipment = '';
      this.showDeviceResultBanner = false;
    }
  }

  public checkAddressCompatibility(): void {
    this.addressCompatibilityForm.form.markAllAsTouched();
    const action = 'freeup_check_address_coverage';
    if (!!this.addressCompatibilityForm.valid && !!this.displayedAddressModel) {
      this.appState.loading = true;
      this.appState.resetAndExecuteCaptchaSubject.next({action});
      this.recaptchaResolvedSubscription= this.appState.resolvedCaptcha.subscribe(response => {
        this.captchaResponse = response;
        if(!!this.captchaResponse) {
          this.recaptchaResolvedSubscription?.unsubscribe();
          this.callAddressCoverageApi(this.captchaResponse, true, action);
        }
      });
    }
  }
  public callAddressCoverageApi(captchaRes, invisibleCaptchaRes, action?): void {
    this.equipmentService.checkNetworkCoverageByAddress(captchaRes, this.displayedAddressModel?.postalCode,
      this.displayedAddressModel?.address1, this.displayedAddressModel?.city,
      this.displayedAddressModel?.state, this.displayedAddressModel?.address2, !!action? action: null, invisibleCaptchaRes).then(res => {
        this.appState.loading = false;
        if (!!this.simValidity) {
          const networkObject = res?.coveredNetworks.find(i => i?.network === this.simValidity.network);
          this.isFromActivation = !!networkObject ? false : true;
          this.showAddressErrorBanner = this.isFromActivation;
          this.showAddressSuccessBanner = !this.showAddressErrorBanner;
          this.addressCompatibilityResponse = res;
        } else {
          this.isFromActivation = false;
          this.showAddressErrorBanner = res.covered ? false : true;
          this.showAddressSuccessBanner = !this.showAddressErrorBanner;
          this.addressCompatibilityResponse = res;
        }
      }, error => {
        this.handleAddressCompatibilityError(error);
      }).catch((error) => {
        this.handleAddressCompatibilityError(error);
      });
  }
  public handleAddressCompatibilityError(error) {
    this.appState.loading = false;
    let errorMessage;
    if (!!error) {
      const errorDetails = error?.error?.errors?.[0];
      errorMessage = errorDetails?.message;
    if(errorDetails?.code === CAPTCHA_BOT_ERROR_CODE) {
      this.modalHelper.showRecaptchaVerificationModal().afterClosed().subscribe((result)=> {
        if(!!result) {
          this.appState.loading = true;
          this.callAddressCoverageApi(result, false);
        }
      });
     } else {
      this.showAddressErrorBanner = true;
      this.isFromActivation = false;
      if (errorDetails?.code === 102) {
        const paramName = errorDetails.params[0]?.param_name;
        const paramMessage = errorDetails.params[0]?.message;

        if (paramName.includes('equipment')) {
          errorMessage = PARAM_ERROR_MESSAGES.IMEI;
        } else if (paramMessage === 'Invalid zip code') {
          errorMessage = PARAM_ERROR_MESSAGES.ADDRESS;
        }
      }
       // If it's not a compatibility error, use the original error message
       this.currentAddressErrorMesssage = errorMessage || PARAM_ERROR_MESSAGES.GENERIC;
     }
    } else {
      this.showAddressErrorBanner = true;
      this.isFromActivation = false;
      this.currentAddressErrorMesssage = `The device you checked does not support the ${!!this.simValidity.eSim ? 'eSIM' : 'physical SIM'} that you have. Please try another device.`;
    }
  }

  public checkDeviceCompatibility(): void {
    this.equipmentCompatibilityForm.form.markAllAsTouched();
    const action = 'freeup_check_imei_coverage';
    if (!!this.equipmentCompatibilityForm.valid && !!this.displayedAddressModel) {
      this.appState.loading = true;
      this.appState.resetAndExecuteCaptchaSubject.next({action});
      this.recaptchaResolvedSubscription= this.appState.resolvedCaptcha.subscribe(response => {
        this.captchaResponse = response;
        if(!!this.captchaResponse) {
          this.recaptchaResolvedSubscription?.unsubscribe();
          this.callDeviceCoverageApi(this.captchaResponse, true, action);
          }
        });
    }
  }

  public callDeviceCoverageApi(captchaRes, invisibleCaptchaRes, action?): void {
    this.equipmentService.checkNetworkCoverageByImei(captchaRes, this.displayedAddressModel?.postalCode,
      this.displayedAddressModel?.address1, this.displayedAddressModel?.city,
      this.displayedAddressModel?.state, this.equipment, this.displayedAddressModel?.address2,null, !!action? action: null, invisibleCaptchaRes).then(results => {
        this.appState.loading = false;
        if (!!results?.equipmentCoverage?.defaultSim) {
          this.defaultSIM = results.equipmentCoverage.defaultSim;
        } else {
          const attCovered = results?.equipmentCoverage?.simOptions.some((i) => i.network === ATT);
          const esimCapable = results?.equipmentCoverage?.simOptions[0].details.eSimCapable; // we need to check if we have to default to esim or physical sim based on the device
          if (!!attCovered) {
            const attOption = !!esimCapable && results?.equipmentCoverage?.simOptions.some((i) => i.network === ATT && i.simType === 'esim') ? results?.equipmentCoverage?.simOptions.find((i) => i.network === ATT && i.simType === 'esim') : results?.equipmentCoverage?.simOptions.find((i) => i.network === ATT && i.simType === 'sim');
            this.defaultSIM = attOption;
          } else {
            const tmoOption = !!esimCapable && results?.equipmentCoverage?.simOptions.some((i) => i.network === TMO && i.simType === 'esim') ? results?.equipmentCoverage?.simOptions.find((i) => i.network === TMO && i.simType === 'esim') : results?.equipmentCoverage?.simOptions.find((i) => i.network === TMO && i.simType === 'sim');
            this.defaultSIM = tmoOption;
          }
        }
        if (!!this.simValidity) {
          if ((!!this.simValidity.eSim && !this.defaultSIM?.details?.eSimCapable) || (!this.simValidity.eSim && !!this.defaultSIM?.details?.eSimOnly)) {
            this.handleCompatibilityError();
          } else {
            if (!this.simValidity.eSim && !!this.defaultSIM?.details?.eSimCapable) {
              this.defaultSIM = results?.equipmentCoverage?.simOptions.find((i) => i.network === this.simValidity?.network && i.simType === 'sim');
            }
            this.defaultSIM.simType = !!this.simValidity.eSim ? 'esim':'sim';
            this.defaultSIM.details.skuIdentifier = this.simValidity.skuIdentifier;
            this.defaultSIM.details.skuNumber = this.simValidity.skuNumber;
            this.defaultSIM.details.network = this.simValidity.network;
            this.handleSuccess();
          }
        } else {
          this.handleSuccess();
        }

      }, error => this.handleCompatibilityError(error)).catch((error)=>{
        this.handleCompatibilityError(error);
      })
  }
  public handleSuccess(): void {
    this.populatePhoneDetails(this.defaultSIM);
    this.setDevice(this.compatibleDevice, this.defaultSIM.simType.toLowerCase() === 'esim');
    this.checkPhoneResult(this.defaultSIM?.details?.eSimOnly, this.defaultSIM.simType.toLowerCase() === 'esim');
  }
  public handleCompatibilityError(error?) {
    this.appState.loading = false;
    this.recaptchaResolvedSubscription?.unsubscribe();
    let errorMessage ;
    if(!!error) {
      const errorDetails = error?.error?.errors[0];
      errorMessage = errorDetails?.message;
  
      if(errorDetails?.code !== CAPTCHA_BOT_ERROR_CODE) {
        if (errorDetails?.code === 102) {
          const paramName = errorDetails.params[0]?.param_name;
          const paramMessage = errorDetails.params[0]?.message;
  
          if (paramName.includes('equipment') || paramName.includes('imei')) {
            errorMessage = PARAM_ERROR_MESSAGES.IMEI;
          } else if (paramMessage === 'Invalid zip code') {
            errorMessage = PARAM_ERROR_MESSAGES.ADDRESS;
          }
        }
        // If it's not a compatibility error, use the original error message
         errorMessage = errorMessage || errorDetails?.message;
  
         this.currentErrorMesssage = errorMessage || PARAM_ERROR_MESSAGES.GENERIC;
         this.showDeviceResultBanner = true;
      }
       else if(errorDetails?.code === CAPTCHA_BOT_ERROR_CODE) {
        this.modalHelper.showRecaptchaVerificationModal().afterClosed().subscribe((result)=> {
          if(!!result) {
            this.appState.loading = true;
            this.callDeviceCoverageApi(result, false);
          }
        });
       }
    } else {
      this.currentErrorMesssage = `The device you checked does not support the ${!!this.simValidity.eSim ? 'eSIM' : 'physical SIM'} that you have. Please try another device.`;
      this.showDeviceResultBanner = true;
    }
  }
  public async setDevice(device, eSim?): Promise<void> {
    device.verified = true;
    await this.mobileCustomPlansService.setAutoRenewPlan(true);
    await this.mobileCustomPlansService.setBasePlan(this.newPlan);
    await this.mobileCustomPlansService.setCartType(CART_TYPES.NEW_PLAN);
    await this.mobileCustomPlansService.setPlanDevice(device);
    if (!!eSim) {
      await this.mobileCustomPlansService.seteSIM(true);
      await this.mobileCustomPlansService.setQrScanned(false);
    } else {
      await this.mobileCustomPlansService.seteSIM(false);
      await this.mobileCustomPlansService.setQrScanned(false);
    }
    await this.mobileCustomPlansService.removePhonesFromCart();
    await this.mobileCustomPlansService.setPlanExpectedDevice(null);
  }

  public checkPhoneResult(esimOnly?: boolean, eSimCapable?: boolean): void {
    const params = {};
    params[ACTIVATION_ROUTE_URLS.PARAMS.NETWORK] = this.compatibleDevice.network;
    params[ACTIVATION_ROUTE_URLS.PARAMS.ZIP_CODE] = this.displayedAddressModel.postalCode;
    if (!!esimOnly) {
      params[ACTIVATION_ROUTE_URLS.PARAMS.ESIMOnly] = true;
    } else if (!!eSimCapable) {
      params[ACTIVATION_ROUTE_URLS.PARAMS.ESIM] = true;
    }
    this.router.navigate([`${ACTIVATION_ROUTE_URLS.BASE}/${ACTIVATION_ROUTE_URLS.CHECK_PHONE_RESULT}`, params]);
  }

  public populatePhoneDetails(phoneDetails) {
    this.compatibleDevice = phoneDetails?.details as IDeviceCompatibilityV1;
    this.compatibleDevice.manufacturer = phoneDetails?.details?.make;
    this.compatibleDevice.marketingName = phoneDetails?.details?.name;
    this.compatibleDevice.address1 = this.displayedAddressModel?.address1;
    this.compatibleDevice.address2 = this.displayedAddressModel?.address2;
    this.compatibleDevice.city = this.displayedAddressModel?.city;
    this.compatibleDevice.state = this.displayedAddressModel?.state;
    this.compatibleDevice.postalCode = this.displayedAddressModel?.postalCode;
    this.compatibleDevice.id = phoneDetails?.details?.serialNumber;
  }
  public showWhatIsIMEI(): void {
    this.modalHelper.showInformationMessageModal('3 Ways to find your IMEI', '', 'Got it', null, true, 'compatibility-help-modal-IME ',
      `<div class="description-content">
      <div class="intro">
        Your IMEI number is needed if you want to unlock your device to use on other networks. Here’s 3 ways how to find it on your phone: </div>
      <div class="note-dial"> <b>Enter *#06# on your phone’s dial pad.</b></div>
      <b>OR</b>
      <div class="menu-margins">
        <b>Check your phone’s settings menu:</b>
        <p class="p-nowrap">Android: Go to Settings > About device > Status</p>
        <p class="p-nowrap">iPhone: Go to Settings > General > About</p>
        <p class="p-nowrap">Windows Phone: Go to Settings > About > More info</p>
      </div>
      <b>OR</b>
      <div class="menu-margins">
        <p class="p-nowrap"><b>Check the sticker under your device’s battery.</b></p>
        <p class="p-nowrap"> Note: It may be listed as “DEC.” </p> </div>
      </div>`);
  }

  public async skipDevice(): Promise<void> {
    //TODO update the device object to be read from the API response after the check by address API is fixed to return the info for both esim and physical sim
    // const tmoNetworkObject = this.addressCompatibilityResponse?.coveredNetworks.find(i => i?.network === TMO);
    const attNetworkObject = this.addressCompatibilityResponse?.coveredNetworks.find(i => i?.network === ATT);
    if (!!attNetworkObject) {
      this.modalHelper.showSkipModal('Skip Device Check', true, 'skip-modal').afterClosed().subscribe(async (option) => {
        console.info('option ', option)
        if (!!option) {
          this.appState.loading = true;
          const device = SKIP_DEVICE_ATT as IDeviceCompatibilityV1 ;
          await this.setDevice(device);
          this.mobileCustomPlansService.seteSIM(false);
          this.appState.loading = false;
          this.router.navigate([`${SHOP_ROUTE_URLS.BASE}/${SHOP_ROUTE_URLS.CART}`]);
        
        } else {
          this.equipmentNumber.nativeElement.focus();
        }
      });
    } else {
      this.mobileCustomPlansService.clearUserCart();
      this.equipmentNumber.nativeElement.focus();
    }
  }

  public notcompatibileDevice(response?: any): void {
    console.error(response);
    if (!!response) {
      this.toastHelper.showAlert(response);
    }
    this.processingRequest = false;
    this.invalidIMEI = true;
  }

  private getAddressValues(placeInfo: any, searchTerms?: string): IFirebaseAddress {
    let address: IFirebaseAddress = {
      name: !!this.displayedAddressModel?.name
        ? this.displayedAddressModel?.name
        : this.displayedAddressModel?.alias,
      address1: placeInfo.address1,
      address2: placeInfo.address2,
      state: placeInfo.state ? placeInfo.state.toUpperCase() : placeInfo.state,
      city: placeInfo.city,
      country: placeInfo.country || 'United States',
      postalCode: placeInfo.postalCode,
    } as IFirebaseAddress;

    if (!!this.displayedAddressModel?.id) {
      address.id = this.displayedAddressModel?.id;
      address.isDefault = this.displayedAddressModel?.isDefault;
    }
    if (!!searchTerms && typeof searchTerms === 'string') {
      if (!!this.streetSearchText) {
        if (!searchTerms.match(this.streetSearchText)) {
          this.streetSearchText = null;
        }
      }
      address.address1 = !!this.streetSearchText
        ? address.address1
        : searchTerms.trim();
    }
    if (!!address && address.address1)
      address.address1 = AccountPaymentService.shortenAddress(address.address1, 30);

    // Clean Out empty values,
    address = this.appState.removeEmptyValues(address);
    return Object.assign({}, address);
  }
}
